import styled from 'styled-components';

import { COLORS } from 'constants/colors';
import { FONTS, FONTS_WEIGHT } from 'constants/fonts';

export const Container = styled.div<{ percentage: number }>`
  width: 472px;
  height: 40px;
  border-radius: 8px;
  background-color: ${COLORS.BgContainer};
  border: 1px solid ${COLORS.Grey10};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding: 0px 12px 0px 20px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${({ percentage }) => percentage}%;
    background-color: ${COLORS.Blue2};
    z-index: 0;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  &:hover {
    border: 1px solid ${COLORS.geekBlue5};
  }
  cursor: pointer;
`;

export const ValuesWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const OptionValue = styled.p`
  font-size: ${FONTS.BASE_TEXT_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
  line-height: 22px;
  text-align: right;
  padding-left: 8px;
`;

export const OptionVotes = styled.p`
  font-size: ${FONTS.TEXT_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_REGULAR};
  line-height: 20px;
  text-align: right;
  padding-left: 10px;
`;

export const SubmitButton = styled.button`
  background-color: ${COLORS.Green5};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  margin-left: 288px;

  &:hover {
    background-color: ${COLORS.Green6};
  }

  &:disabled {
    background-color: ${COLORS.Grey2};
    color: ${COLORS.Grey3};
    border: 1px solid ${COLORS.Grey3};
    cursor: not-allowed;
  }
`;

export const textOptionStyles = {
  paddingLeft: '10px',
  fontSize: FONTS.BASE_TEXT_FONT,
  fontWeight: FONTS_WEIGHT.TEXT_BOLD,
  lineHeight: '22px',
  textAlign: 'left' as any,
  marginBottom: 0,
  whiteSpace: 'nowrap',
  maxWidth: '316px',
};
